// extracted by mini-css-extract-plugin
export var aboveInput = "_in-0";
export var actionButton = "_in-5";
export var actionButtonContainer = "_in-1";
export var actionIcon = "_in-6";
export var aiInfoContainer = "_in-2";
export var attachmentWrapper = "_in-7";
export var bold = "_in-3";
export var checkIcon = "_in-8";
export var clickingRecipientBar = "_in-11";
export var commentThreadSwitch = "_in-a";
export var draftImage = "_in-b";
export var draftImageContainer = "_in-c";
export var draftImages = "_in-e";
export var editButton = "_in-g";
export var editor = "_in-f";
export var editorContainer = "_in-y";
export var editorErrorTooltipWrapper = "_in-9";
export var headerDivider = "_in-h";
export var icon = "_in-i";
export var info = "_in-j";
export var internal = "_in-n";
export var internalDivider = "_in-k";
export var internalMessage = "_in-l";
export var messageInputCard = "_in-m";
export var messageInputForm = "_in-o";
export var messageInputFormInternal = "_in-p";
export var options = "_in-q";
export var publicMessageCustomer = "_in-s";
export var publicMessageMerchant = "_in-r";
export var removeImageButton = "_in-d";
export var replyButtons = "_in-t";
export var showSignatureButton = "_in-u";
export var spinner = "_in-v";
export var verticalButtonDivider = "_in-4";
export var visibilitySelector = "_in-w";
export var warning = "_in-x";
export var wrappingText = "_in-z";
export var writingInternalNoteTopBorder = "_in-10";